module.exports = __webpack_public_path__ + "img/logo-iap.cfc04aa6.png";